// @ts-nocheck

import api from "@/api/news"

export default {
  // Public news actions
  async fetchAllPublicNews({commit}: any) {
    try {
      commit("setPublicNewsLoading", true)
      const res = await api.getPublicNews()
      const results = res.results || res || []
      
      // Сортировка по дате создания (новые сначала)
      const sortedNews = results.sort((a: any, b: any) => {
        const dateA = new Date(a.created_at || 0).getTime()
        const dateB = new Date(b.created_at || 0).getTime()
        return dateB - dateA
      })
      
      commit("setAllPublicNews", sortedNews)
      commit("setPublicNewsPagination", {
        total: sortedNews.length,
      })
      commit("setPublicNewsLoading", false)
      return sortedNews
    } catch (error) {
      commit("setPublicNewsLoading", false)
      return {error: error.response?.data || error}
    }
  },
  
  async fetchPublicNewsDetail({commit}: any, id: number | string) {
    try {
      const res = await api.getPublicNewsById(id)
      // Update read status in store
      commit("updatePublicNewsReadStatus", id)
      return res
    } catch (error) {
      return {error: error.response?.data || error}
    }
  },
  
  paginatePublicNews({commit, state}: any, {current, pageSize}: {current: number; pageSize: number}) {
    const start = (current - 1) * pageSize
    const end = start + pageSize
    const paginatedNews = state.allPublicNews.slice(start, end)
    
    commit("setPublicNews", paginatedNews)
    commit("setPublicNewsPagination", {
      current,
      pageSize,
    })
  },
  
  async loadPublicNewsWithPagination({dispatch}: any, {current, pageSize}: {current: number; pageSize: number}) {
    await dispatch("fetchAllPublicNews")
    dispatch("paginatePublicNews", {current, pageSize})
  },
  
  async fetchAllNews({commit}: any) {
    try {
      commit("setLoading", true)
      const res = await api.getNews()
      const allNews = res.results || res || []
      
      // Сортировка по дате создания (новые сначала)
      const sortedNews = allNews.sort((a: any, b: any) => {
        const dateA = new Date(a.created_at || 0).getTime()
        const dateB = new Date(b.created_at || 0).getTime()
        return dateB - dateA
      })
      
      commit("setAllNews", sortedNews)
      commit("setPagination", {
        total: sortedNews.length,
      })
      commit("setLoading", false)
      return sortedNews
    } catch (error) {
      commit("setLoading", false)
      return {error: error.response?.data || error}
    }
  },
  
  async fetchNewsById({commit}: any, id: number | string) {
    try {
      const res = await api.getNewsById(id)
      return res
    } catch (error) {
      return {error: error.response?.data || error}
    }
  },
  
  paginateNews({commit, state}: any, {current, pageSize}: {current: number; pageSize: number}) {
    const start = (current - 1) * pageSize
    const end = start + pageSize
    const paginatedNews = state.allNews.slice(start, end)
    
    commit("setNewsList", paginatedNews)
    commit("setPagination", {
      current,
      pageSize,
    })
  },
  
  async createNews({commit, dispatch, state}: any, payload: any) {
    try {
      const res = await api.createNews(payload)
      commit("addNews", res)
      
      // Обновляем пагинацию с текущими параметрами
      commit("setPagination", {
        total: state.allNews.length,
      })
      dispatch("paginateNews", {
        current: state.pagination.current,
        pageSize: state.pagination.pageSize,
      })
      
      return res
    } catch (error) {
      return {error: error.response?.data || error}
    }
  },
  
  async updateNews({commit, dispatch, state}: any, {id, payload}: {id: number | string; payload: any}) {
    try {
      const res = await api.updateNews(id, payload)
      commit("updateNewsItem", res)
      
      // Обновляем пагинацию с текущими параметрами
      dispatch("paginateNews", {
        current: state.pagination.current,
        pageSize: state.pagination.pageSize,
      })
      
      return res
    } catch (error) {
      return {error: error.response?.data || error}
    }
  },
  
  async deleteNews({commit, dispatch, state}: any, id: number | string) {
    try {
      await api.deleteNews(id)
      commit("removeNews", id)
      
      // Обновляем пагинацию
      const newTotal = state.allNews.length
      let newCurrent = state.pagination.current
      
      // Если удалили последний элемент на странице, переходим на предыдущую
      const maxPage = Math.ceil(newTotal / state.pagination.pageSize)
      if (newCurrent > maxPage && maxPage > 0) {
        newCurrent = maxPage
      }
      
      commit("setPagination", {
        total: newTotal,
        current: newCurrent,
      })
      
      dispatch("paginateNews", {
        current: newCurrent,
        pageSize: state.pagination.pageSize,
      })
      
      return {success: true}
    } catch (error) {
      return {error: error.response?.data || error, success: false}
    }
  },
  
  async deactivateAllNews({dispatch, state}: any) {
    try {
      await api.deactivateAllNews()
      await dispatch("fetchAllNews")
      dispatch("paginateNews", {
        current: 1,
        pageSize: state.pagination.pageSize,
      })
      return {success: true}
    } catch (error) {
      return {error: error.response?.data || error, success: false}
    }
  },
}

